module.exports = __webpack_public_path__ + "img/title.1e2fb268.png";